import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info" }

import SocialMediaButtons from "@/components/Common/SocialMediaButtons.vue";

import { defineComponent } from 'vue'

const __default__ = defineComponent({
    name: 'GameInfo',

    data() {
        return {
        }
    },
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h5", null, "Приветствуем тебя, пилот!", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("p", null, [
      _createElementVNode("span", { class: "highlighted" }, "«Космические Скауты»"),
      _createTextVNode(" - это браузерная многопользовательская пошаговая игра на космическую тему.")
    ], -1)),
    _cache[2] || (_cache[2] = _createElementVNode("p", null, "Здесь тебя ждут увлекательные бои, межпланетные и межзвёздные путешествия, правительственные квесты, торговля, колонизация планет, крафт, профессии, кланы и многое другое!", -1)),
    _createVNode(SocialMediaButtons)
  ]))
}
}

})